import { render, staticRenderFns } from "./StadiumFieldCreateAndUpdateFormItems.vue?vue&type=template&id=43c67ba5&"
import script from "./StadiumFieldCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumFieldCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c67ba5')) {
      api.createRecord('43c67ba5', component.options)
    } else {
      api.reload('43c67ba5', component.options)
    }
    module.hot.accept("./StadiumFieldCreateAndUpdateFormItems.vue?vue&type=template&id=43c67ba5&", function () {
      api.rerender('43c67ba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumFieldCreateAndUpdateFormItems.vue"
export default component.exports